export const getEmptyMarketsForNotClassicView = (twoWay?: boolean) => {
  const EMPTY_MARKETS: {
    id: number;
    type: string;
    name: string;
    order: number;
    group_id: number;
    group_name: string;
    event: Record<
      string,
      {
        id: number;
        type: string;
        type_1: string;
        price: number;
        name: string;
        order: number;
      }
    >;
  } = {
    id: -1,
    type: 'P1XP2',
    name: 'P1XP2',
    order: 0,
    group_id: 0,
    group_name: 'Winner',
    event: {
      '-1': {
        id: -1,
        type: 'W1',
        type_1: 'W1',
        price: 0,
        name: 'W1',
        order: 0
      },
      '-2': {
        id: -2,
        type: 'X',
        type_1: 'X',
        price: 0,
        name: 'X',
        order: 1
      },
      '-3': {
        id: -3,
        type: 'W2',
        type_1: 'W2',
        price: 0,
        name: 'W2',
        order: 2
      }
    }
  };

  if (twoWay) {
    delete EMPTY_MARKETS.event['-2'];
  }

  return EMPTY_MARKETS;
};
